export default __webpack_public_path__ + "static/media/icon-edit.eefcfd66.svg";